import * as React from 'react';
const SvgPath = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M0 0h24v24H0z" />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M18.73 8.91A3.001 3.001 0 0 0 18 3a3 3 0 0 0-1.262 5.723c-.171 1.387-.436 3.01-.821 4.304-.208.699-.433 1.236-.659 1.581-.124.19-.21.267-.25.296-.067-.028-.246-.131-.539-.491-.422-.519-.941-1.408-1.552-2.812-.64-1.47-1.245-2.55-1.834-3.276-.564-.693-1.282-1.265-2.16-1.239-.895.027-1.494.658-1.856 1.212-.38.583-.67 1.334-.9 2.104-.438 1.47-.72 3.25-.897 4.687A3.001 3.001 0 0 0 6 21a3 3 0 0 0 1.262-5.722c.172-1.388.436-3.01.822-4.305.208-.699.433-1.237.658-1.582.124-.19.21-.266.251-.295.066.028.245.13.538.49.422.52.942 1.408 1.552 2.813.64 1.47 1.245 2.55 1.835 3.276.564.693 1.28 1.264 2.158 1.238.897-.026 1.495-.657 1.857-1.212.38-.582.671-1.333.9-2.103.439-1.47.721-3.25.897-4.687M18 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2M6 19a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgPath;
